import React from "react";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import Leftarrow from "../../assets/images/Leftarrow.svg";
import TermsViewer from "../../screens/onboarding/termsViewer";
import "./terms-and-conditions.scss";
import { Tooltip } from "antd";

export default function TermsAndCondition() {
  const navigate = useNavigate();

  const location = useLocation();
  const { state } = location;

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate("/frontend", {
        state: {
          data: state?.formData,
        },
      });
    }
  };

  return (
    <motion.div
      className="terms-and-conditions-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="container">
        <div className="apply-header">
          <div>
            <Tooltip title="Go back">
              <img
                className="back-btn"
                src={Leftarrow}
                onClick={handleBack}
                alt="back button"
              />
            </Tooltip>
          </div>
          <div>
            <h2>Terms and Conditions</h2>
          </div>
          <div>
            {/* <CloseOutlined /> */}
          </div>
        </div>

        <div className="terms-text">
          <TermsViewer />
        </div>
      </div>
    </motion.div>
  );
}
